module.exports = __webpack_public_path__ + "static/media/person-default-picture.263a2ab6.png";